
<script setup>
  import MainMenu from '../MainMenu.vue'
</script>
<template>
  <div id="games" v-if="!showMenu">
    <div class="squareGame animated slideInLeft menu-open"
         :class="{ 'hover-active': hover }"
        @mouseenter="handleHover(true)"
        @mouseleave="handleHover( false)"
         @click="goToMenu">
      <div class="imgGame homepage"></div>
      <span class="gameTitle">Menu</span>
    </div>
  </div>
  <button class="close-btn animated fadeIn" @click="closeMenu" v-if="showMenu">X</button>

    <MainMenu v-if="showMenu" />

</template>

<script>
export default {
  data() {
    return {
      showMenu: false, // Controls menu visibility
      hover: false,
      firstLoad:true
    };
  },
  watch: {
    $route(to, from) {
      /*console.log("Route changed from:", from.path, "to:", to.path);*/
      //if (this.$route.path !== '/') {
      if (!this.firstLoad) {
        this.closeMenu(); // Hide the menu on route change
      }
      //}
      //else {
      //  this.goToMenu();
      //}
    }
  },
  methods: {
      handleHover(isEntering) {
        this.hover = isEntering;
      },
    goToMenu() {
      this.firstLoad = false;

      let menu = document.querySelector('.menu-container'); // Add a wrapper in MainMenu.vue
      if (menu) {
        menu.classList.remove('slideOutLeft');
        menu.classList.add('slideInLeft');
      }
      // Start animation by adding a class
      let container = document.querySelector('.container');
      container.classList.remove('slideInRight');
      container.classList.add('slideOutRight');
      let menuOpenButton = document.querySelector('.menu-open')
      menuOpenButton.classList.remove('slideInLeft');
      menuOpenButton.classList.add('slideOutLeft');

      // Wait for animation to finish before switching
      setTimeout(() => {
        this.hover = false;
        this.showMenu = true;
        container.classList.add('hide');
      }, 250); // Matches the CSS transition time
    },
    closeMenu() {
      // Start reverse animation
      let menu = document.querySelector('.menu-container'); // Add a wrapper in MainMenu.vue
      if (menu) {
        menu.classList.remove('slideInLeft');
        menu.classList.add('slideOutLeft');
      }

      // Wait for animation to finish before switching back
      setTimeout(() => {
        this.showMenu = false;
        let container = document.querySelector('.container');
        container.classList.remove('hide');

        // Restore home button animation
        let menuOpenButton = document.querySelector('.menu-open');
        if (menuOpenButton) {
          menuOpenButton.classList.remove('slideOutLeft');
          menuOpenButton.classList.add('slideInLeft');
        }
        container.classList.remove('slideOutRight');
        container.classList.add('slideInRight');
      }, 250);
    }
  }
};
</script>


<style scoped>
  .close-btn {
    position: absolute;
    top: 15px;
    right: 20px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    border: none;
    padding: 10px 15px;
    cursor: pointer;
    font-size: 18px;
    border-radius: 5px;
    transition: background 0.3s;
    display: block;
    width: inherit;
  }

    .close-btn:hover {
      background: rgba(255, 0, 0, 0.8);
    }

  .menu-container {
    position: relative;
  }
</style>
